/**
 * Neutralise spreadsheet formula injection for free-text CSV cells that guests control.
 * Excel / Sheets treat a leading `=`, `@`, tab or CR as a formula, and a leading `+` / `-` when
 * followed by anything that is not a plain number. Prefixing with a single quote makes the cell
 * literal text. Numeric-looking values such as E.164 phone numbers (`+61 412 345 678`) are left
 * untouched so they do not render with a visible apostrophe.
 */
const PHONE_LIKE = /^[+-][\d\s().-]*$/;
export function csvText(v) {
    const s = v == null ? '' : String(v);
    if (!s)
        return s;
    const c = s[0];
    if (c === '=' || c === '@' || c === '\t' || c === '\r') {
        return `'${s}`;
    }
    if ((c === '+' || c === '-') && !PHONE_LIKE.test(s)) {
        return `'${s}`;
    }
    return s;
}
//# sourceMappingURL=index.js.map